import { useContext } from 'react'

import { ButtonContext } from '../contexts/button-context'

export function useButtonProps() {
  const props = useContext(ButtonContext)
  return props
}
